import { useState } from "react";
import { Link2, Check, Facebook, Linkedin, Twitter, Share2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "../lib/api";

export default function JobShare({ jobKey, title }) {
  const [copied, setCopied] = useState(false);
  const url = `${API}/share/jobs/${jobKey}`;
  const text = `Now hiring: ${title} — Integrity Delivered, Baltimore MD`;
  const enc = encodeURIComponent;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Job link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Could not copy link"); }
  };
  const native = async () => {
    if (navigator.share) { try { await navigator.share({ title: text, text, url }); } catch {} } else copy();
  };

  const btn = "w-8 h-8 rounded-full border border-slate-700 bg-slate-950 flex items-center justify-center text-slate-400 hover:text-amber-400 hover:border-amber-500/60 transition-colors";
  const links = [
    { id: "facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`, label: "Facebook" },
    { id: "linkedin", Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`, label: "LinkedIn" },
    { id: "x", Icon: Twitter, href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}`, label: "X" },
  ];

  return (
    <div data-testid={`job-share-${jobKey}`} className="mt-3 flex items-center gap-2">
      <span className="text-[10px] uppercase tracking-widest text-slate-500 mr-1">Share job</span>
      {links.map((l) => (
        <a key={l.id} data-testid={`job-share-${l.id}-${jobKey}`} href={l.href} target="_blank" rel="noreferrer" className={btn} title={`Share on ${l.label}`}><l.Icon className="w-3.5 h-3.5" /></a>
      ))}
      <button data-testid={`job-share-copy-${jobKey}`} onClick={copy} className={btn} title="Copy job link">{copied ? <Check className="w-3.5 h-3.5 text-emerald-400" /> : <Link2 className="w-3.5 h-3.5" />}</button>
      <button data-testid={`job-share-native-${jobKey}`} onClick={native} className={`${btn} sm:hidden`} title="Share"><Share2 className="w-3.5 h-3.5" /></button>
    </div>
  );
}
